import { Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { SnackSimple } from "../../../../../../components"
import { useBody } from "./hooks/body"
import { ListDailyCuts } from "./components/listDailyCuts"
import { ResendDailyCuts } from "./components/resendDailyCuts"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { useInput } from "./hooks/useInput"

export const DailyCuts = () => {

    const styles = useStyles()
    const { inputCreate, createFilter, indexFilter, inputFilter } = useInput()
    const { column, all, handleSubmit, cutsNoSelected, totalCuts, totalPages, setStep, row, step, columnUsers, cutsSelected, usersSelected, setUsersSelected, closeSnackbar, loadings, modalLoad, searchUsers, snackbar } = useBody(createFilter,indexFilter)


    const CurrentStep = () => {
        switch (step) {
            case 0:
                return (
                    <ListDailyCuts 
                        column={column} 
                        row={row} 
                        setStep={setStep} 
                        filter={<DinamicForm input={Object.values(inputFilter)} values={indexFilter.filterData} onChange={indexFilter.onChange} />}
                        cleanFilter={indexFilter.cleanFilter}
                        counter={indexFilter.counter ?? 0}
                        loading= {!!loadings.table}
                        totalPages={totalPages}
                        indexFilter={indexFilter}
                        cutsSelected={cutsSelected}
                        all={all}
                        cutsNoSelected={cutsNoSelected}
                    />
                )
            case 1:
                return (
                    <ResendDailyCuts
                        setStep={setStep}
                        rigthItem={<DinamicForm input={Object.values(inputCreate ?? {})} onChange={createFilter.onChange} errors={createFilter.errors} values={createFilter.filterData} />}
                        column={columnUsers}
                        row={modalLoad?.tmpUsuers}
                        cleanFilter={() => { createFilter.cleanFilter() }}
                        searchButton={{
                            disabled: !createFilter.query?.filter,
                            loading: !!loadings.search,
                            onClick: searchUsers
                        }}
                        setUsersSelected={setUsersSelected}
                        usersSelected={usersSelected}
                        cutsSelected={cutsSelected}
                        totalCuts={totalCuts}
                        cutsNoSelected={cutsNoSelected}
                        all={all}
                        handleSubmit={handleSubmit}
                        submit={loadings.submit}
                    />
                )
            default:
                return null
        }
    }


    return (
        <Box sx={styles.conteiner}>
            <Box>
                {CurrentStep()}
            </Box>
            <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />
        </Box>
    )
}